import React from 'react';
import { Divider, Layout} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faChevronLeft, faChevronRight } from '@fortawesome/pro-duotone-svg-icons'
// import { MainMenu } from './main-menu';
import {MainMenu} from '../../routers/router-principal';

import './side-menu.css';


const {Sider} = Layout;

class SideMenu extends React.Component {


  constructor(props){
    super(props);
    this.state = {
      collapsed: false,
      showSlider: true

    }
  }

  toogleColapse = () => {
    const collapsed = !this.state.collapsed;
    this.setState({collapsed});
  }

  onBreakpoint = broken => {
    
      const collapsed = broken;
      this.setState({collapsed});
      
    
  }

  render = () => {
    let img = <></>;
    let icon = <FontAwesomeIcon icon={faChevronRight} />
    if(!this.state.collapsed){
      img = <img src='/logo-fundo-claro.png' alt='logo' className='logo'></img>;
      icon = <FontAwesomeIcon icon={faChevronLeft} />
    }

    

    return (
      <Sider 
            collapsed={this.state.collapsed} 
            theme='light' 
            width={288} 
            breakpoint="md"
            className="siderDesktop"
            style={{
                overflow: 'auto',
                height: '100vh',
                left: 0,
                zIndex: 20
            }}
            onBreakpoint={this.onBreakpoint}
      >
        <div className='side-menu'>
          {img}
      
          <div className='colapse-wrapper'>
            <button onClick={this.toogleColapse}>
              {icon}
            </button>
          </div>
          <Divider plain className='dividerMenu'></Divider>
          <MainMenu />
        </div>
      </Sider>
    );
    
  }
}

export {SideMenu};
